const aboutConfig = {
  route: '/about',
  title: 'About',
};

export default aboutConfig;
